module.exports = __webpack_public_path__ + "media/images/about_solution-pic1-22f75bb9.png";